import {styled} from '@mui/material/styles'
import AppBar from '@mui/material/AppBar'
import {Box, Divider, Toolbar} from '@mui/material'

export const StyledAppBar = styled(AppBar)(({theme}) => ({
  background: theme.palette.blackShade,
  height: '80px'
}))

export const StyledDiv = styled('div')(() => ({
  paddingLeft: '5px',
  paddingRight: '5px',
  display: 'flex',
  alignItems: 'center'
}))

export const StyledBox = styled(Box)(() => ({
  justifyContent: 'space-between',
  display: 'flex',
  alignItems: 'center'
}))

export const StyledLogoImage = styled('img')(() => ({
  height: '22px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}))

export const StyledDivider = styled(Divider)(({theme}) => ({
  backgroundColor: theme.palette.common.white,
  marginLeft: '24px',
  marginRight: '24px'
}))

export const StyledToolBar = styled(Toolbar)(() => ({
  minHeight: '80px',
  '&.MuiToolbar-root': {minHeight: '80px'}
}))

export const StyledImage = styled('img')(() => ({
  height: '28px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}))

export const StyledSuperContainer = styled('div')(() => ({
  width: '60%',
  justifyContent: 'flex-end',
  display: 'flex'
}))
